import { render, staticRenderFns } from "./edit-inboxes.vue?vue&type=template&id=f5255062&scoped=true&"
import script from "./edit-inboxes.vue?vue&type=script&lang=js&"
export * from "./edit-inboxes.vue?vue&type=script&lang=js&"
import style0 from "./edit-inboxes.vue?vue&type=style&index=0&id=f5255062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5255062",
  null
  
)

export default component.exports